import { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { Card, CardText, CardTitle } from 'reactstrap';

export default class CreditCard extends Component{
    render(){
        return (
            <Card body>
                <CardTitle>Credit Card</CardTitle>
                <CardText>
                    Pembayaran dengan Kartu Kredit merupakan pembayaran instan yang sangat mudah digunakan. KICKAVENUE menerima pembayaran Kartu Kredit yang berlogo sebagai berikut:
                </CardText> 
                <CardText className="text-center">
                    <FontAwesome name="cc-visa" size="3x" style={{marginRight:15}}/>
                    <FontAwesome name="cc-mastercard" size="3x" style={{marginRight:15}}/>
                    <FontAwesome name="cc-jcb" size="3x" style={{marginRight:15}}/>
                </CardText>                               
            </Card>
        )
    }
}